import { render, staticRenderFns } from "./EditRecipientWhatsAppVoiceCallItem.vue?vue&type=template&id=364baa5f"
import script from "./EditRecipientWhatsAppVoiceCallItem.vue?vue&type=script&lang=js"
export * from "./EditRecipientWhatsAppVoiceCallItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports